// API Configuration
// In production, the frontend and backend are served from the same domain
// so we use relative URLs. In development, we use the local backend URL.

const getApiUrl = () => {
  // In production, use relative URLs (same domain)
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  // In development, use localhost
  return 'http://localhost:3001/api';
};

export const API_URL = getApiUrl();

// Helper function to build API endpoints
export const buildApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
};

// Export individual API endpoints for convenience
export const API_ENDPOINTS = {
  // Auth
  LOGIN: `${API_URL}/auth/login`,
  LOGOUT: `${API_URL}/auth/logout`,
  VERIFY: `${API_URL}/auth/verify`,

  // Users
  USUARIOS: `${API_URL}/usuarios`,

  // Materials
  MATERIALES: `${API_URL}/materiales`,

  // Labor
  MANO_OBRA: `${API_URL}/mano-obra`,

  // Machinery
  MAQUINARIA: `${API_URL}/maquinaria`,

  // Unit Prices
  PRECIOS_UNITARIOS: `${API_URL}/precios-unitarios`,

  // Budgets
  PRESUPUESTOS: `${API_URL}/presupuestos`,

  // Upload
  UPLOAD: `${API_URL}/upload`,

  // Units
  UNIDADES: `${API_URL}/unidades`,

  // Configuration
  CONFIGURACION: `${API_URL}/configuracion`,

  // Analysis
  ANALISIS_PU: `${API_URL}/analisis-pu`,
  ANALISIS_ARCHIVO: `${API_URL}/analisis-archivo`,

  // Health check
  HEALTH: `${API_URL}/health`
};

export default API_URL;